import { getInstances } from "@studiometa/js-toolkit";
import { nextFrame, removeClass, transition } from "@studiometa/js-toolkit/utils";
function withTransition(BaseClass) {
  class Transition extends BaseClass {
    /**
     * Config.
     */
    static config = {
      name: "Transition",
      options: {
        enterFrom: String,
        enterActive: String,
        enterTo: String,
        enterKeep: Boolean,
        leaveFrom: String,
        leaveActive: String,
        leaveTo: String,
        leaveKeep: Boolean,
        group: String
      }
    };
    /**
     * Get the transition target.
     */
    get target() {
      return this.$el;
    }
    /**
     * Get the group targets.
     */
    get targets() {
      const { group } = this.$options;
      const targets = [this.target];
      if (group) {
        for (const instance of getInstances(this.constructor)) {
          if (instance !== this && instance.$options.group === group) {
            targets.push(instance.target);
          }
        }
      }
      return targets.flat();
    }
    /**
     * Trigger the enter transition.
     */
    async enter(target) {
      const { enterFrom, enterActive, enterTo, enterKeep, leaveTo } = this.$options;
      removeClass(target ?? this.targets, leaveTo);
      await nextFrame();
      await transition(
        target ?? this.targets,
        {
          from: enterFrom,
          active: enterActive,
          to: enterTo
        },
        enterKeep ? "keep" : void 0
      );
    }
    /**
     * Trigger the leave transition.
     */
    async leave(target) {
      const { leaveFrom, leaveActive, leaveTo, leaveKeep, enterTo } = this.$options;
      removeClass(target ?? this.targets, enterTo);
      await nextFrame();
      await transition(
        target ?? this.targets,
        {
          from: leaveFrom,
          active: leaveActive,
          to: leaveTo
        },
        leaveKeep ? "keep" : void 0
      );
    }
  }
  return Transition;
}
export {
  withTransition
};
//# sourceMappingURL=withTransition.js.map
